/**
 * The 'ludum dare' game page.
 * @type {string}
 * @constant
 */
const LUDUM_DARE = 'https://ldj.am/$424583';

export {

    LUDUM_DARE
};
